export default __webpack_public_path__ + "static/media/me3_Icon_EarnAdmission.4a35d640.svg";